import { useQuery } from '@apollo/client';
import type { ProductCard_Key as ProductCardKey } from '__generated__/graphql-types';

import PRODUCT_CARD_REVIEW_RATINGS from 'bundles/product-card/queries/ProductCardReviewRatings.graphql';
import type {
  ProductCardReviewRatingsQuery,
  ProductCardReviewRatingsQueryVariables,
} from 'bundles/product-card/queries/__generated__/ProductCardReviewRatings';

function useProductCardReviewRatings(productCardKeys: ProductCardKey[]) {
  // dedupe productCardKeys to avoid making duplicate requests
  const uniqueProductCardKeys: ProductCardKey[] = [...new Map(productCardKeys.map((item) => [item.id, item])).values()];
  const { loading, error, data } = useQuery<ProductCardReviewRatingsQuery, ProductCardReviewRatingsQueryVariables>(
    PRODUCT_CARD_REVIEW_RATINGS,
    {
      variables: { productCardKeys: uniqueProductCardKeys },
      context: { clientName: 'gatewayGql' },
      skip: !productCardKeys.length,
    }
  );
  return { loading, error, data };
}

export default useProductCardReviewRatings;
